import { Box, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useStyles } from "./style";
import { CheckIcon, MenuIcon } from "./icons";
import { useState } from "react";

export const TimeRangeToggles = () => {
  const classes = useStyles();
  const [selectedRange, setSelectedRange] = useState("All");
  const { t } = useTranslation();
  const handleRangeChange = (
    event: React.MouseEvent<HTMLElement>,
    newValue: string | null
  ) => {
    if (newValue !== null) {
      setSelectedRange(newValue);
    }
  };

  return (
    <Box className={classes.container}>
      <ToggleButtonGroup
        className={classes.toggleGroup}
        value={selectedRange}
        exclusive // ensures only one value can be selected
        onChange={handleRangeChange}
        aria-label="Date Range Toggles"
      >
        <ToggleButton
          className={classes.toggleButton}
          value={t("dashboard.timeRangeToggles.all")}
          aria-label={t("dashboard.timeRangeToggles.all")}
        >
          {selectedRange === t("dashboard.timeRangeToggles.all") && (
            <CheckIcon width={16} height={16} />
          )}
          {t("dashboard.timeRangeToggles.all")}
        </ToggleButton>
        <ToggleButton
          className={classes.toggleButton}
          value={t("dashboard.timeRangeToggles.lastYear")}
        >
          {selectedRange === t("dashboard.timeRangeToggles.lastYear") && (
            <CheckIcon width={16} height={16} />
          )}
          {t("dashboard.timeRangeToggles.lastYear")}
        </ToggleButton>
        <ToggleButton
          className={classes.toggleButton}
          value={t("dashboard.timeRangeToggles.last6Months")}
        >
          {selectedRange === t("dashboard.timeRangeToggles.last6Months") && (
            <CheckIcon width={16} height={16} />
          )}
          {t("dashboard.timeRangeToggles.last6Months")}
        </ToggleButton>
        <ToggleButton
          className={classes.toggleButton}
          value={t("dashboard.timeRangeToggles.lastQuarter")}
        >
          {selectedRange === t("dashboard.timeRangeToggles.lastQuarter") && (
            <CheckIcon width={16} height={16} />
          )}
          {t("dashboard.timeRangeToggles.lastQuarter")}
        </ToggleButton>
        <ToggleButton
          className={classes.toggleButton}
          value={t("dashboard.timeRangeToggles.last30Days")}
        >
          {selectedRange === t("dashboard.timeRangeToggles.last30Days") && (
            <CheckIcon width={16} height={16} />
          )}
          {t("dashboard.timeRangeToggles.last30Days")}
        </ToggleButton>
        <ToggleButton
          className={classes.toggleButton}
          value={t("dashboard.timeRangeToggles.last7Days")}
        >
          {selectedRange === t("dashboard.timeRangeToggles.last7Days") && (
            <CheckIcon width={16} height={16} />
          )}
          {t("dashboard.timeRangeToggles.last7Days")}
        </ToggleButton>
        <ToggleButton
          className={classes.toggleButton}
          value={t("dashboard.timeRangeToggles.last24Hours")}
        >
          {selectedRange === t("dashboard.timeRangeToggles.last24Hours") && (
            <CheckIcon width={16} height={16} />
          )}
          {t("dashboard.timeRangeToggles.last24Hours")}
        </ToggleButton>
      </ToggleButtonGroup>

      <MenuIcon width={24} height={24} />
    </Box>
  );
};
